import { render, staticRenderFns } from "./documents.accountspayable.delete.vue?vue&type=template&id=12db26da&scoped=true"
import script from "./documents.accountspayable.delete.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.delete.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.delete.vue?vue&type=style&index=0&id=12db26da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db26da",
  null
  
)

export default component.exports